/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2023-02-21 14:09:20
 * @LastEditors: zhang lin
 */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { reducerStates } from 'root/store/types';
import { envManage } from '../../store/actions';
import { Spin } from 'sup-ui';

import Icon from 'root/components/Icon';
import HostList from './HostList';
import Detail from '../Detail';

import { ColonyDataType, LabelListType, UpdateHostListType } from '../types';
import messages from '../messages';
import styles from './index.less';

interface IProps {
  data: ColonyDataType;
  updateHostList: any;
}

const Colony = (props: IProps) => {
  const intl = useIntl();
  const { data: { serverNodeBriefs = [], labelStatus = [] } = {}, updateHostList } = props;
  const dispatch = useDispatch();
  const [selectHost, setSelectHost] = useState<string>('all');
  const { singleNodeId, refersh, colonySpinning } = useSelector((state: reducerStates) => state.envManage);

  const handleSelectItem = (item: { label: string; arrStatus?: { ip: string; status?: string }[] }) => {
    setSelectHost(item.label);
    const ids = item?.arrStatus ? item?.arrStatus.map((ele) => ele.ip) : [];
    updateHostList((pre: UpdateHostListType) => ({ ...pre, ids }));
  };

  const getDiffColor = (type: string) => {
    let color = '#0AB129';
    switch (type) {
      case 'DANGER':
        color = '#D20C0C';
        break;
      case 'WARN':
        color = '#D1861B';
        break;
      case 'DEPLOYING':
        color = '#2280FA';
        break;
      default:
        break;
    }

    return color;
  };

  return singleNodeId ? (
    <div className={styles.colony_detail}>
      <div className={styles.colony_head}>
        <div
          onClick={() => {
            dispatch(
              envManage.changeEnvStatus({
                singleNodeId: '', // 清空单主机id
                refersh: !refersh,
              }),
            );
          }}
          className={styles.goBack}
        >
          {intl.formatMessage(messages.goback)}
        </div>
      </div>
      <Detail />
    </div>
  ) : (
    <div className={styles.colony_list}>
      <Spin spinning={colonySpinning} tip={intl.formatMessage(messages.deleteing)}>
        <div className={styles.colony_list_category}>
          <div
            onClick={() => handleSelectItem({ label: 'all' })}
            className={`${styles.all} ${selectHost === 'all' ? styles.active : ''}`}
          >
            {intl.formatMessage(messages.all)}
          </div>
          <div className={styles.list}>
            {labelStatus.map((item) => (
              <div
                style={{ borderColor: selectHost === item.label ? '#2280fa' : '' }}
                onClick={() => handleSelectItem(item)}
                className={styles.listItem}
                key={item.label}
              >
                <div className={styles.title}>
                  <span style={{ width: item.arrStatus.length > 4 ? item.arrStatus.length * 20 : 90 + 'px' }}>
                    {item.label ? item.label : intl.formatMessage(messages.noTag)}
                  </span>
                  <span>{item.arrStatus.length}</span>
                </div>
                <div className={styles.iconItem}>
                  {item.arrStatus.map((ele, index) => (
                    <Icon
                      key={ele.ip + index}
                      type="host20"
                      style={{ fontSize: 20, color: getDiffColor(ele.status) }}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <HostList updateHostList={updateHostList} list={serverNodeBriefs as LabelListType[]} />
      </Spin>
    </div>
  );
};

export default Colony;
